// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = (d, c) => c(require)

import React from 'react'
import { Route, IndexRoute, Redirect } from 'react-router'
import App from '../containers/App'
import Home from '../containers/Home'
//import shell from '../lib/utils/shell'
//import mapPageToTemplate from '../../reduxion-core/lib/mapPageToTemplate'

/**
 * Logic to determine and split app into webpack chunks
 * based on routes
 * @param  {Object}   params parsed routing params
 * @param  {Function} cb     react router callback
 * @return {void}
 */
const getSportComponent = (params = {}, cb) => {

  const { pageType } = params

  switch(pageType) {
    case 'game':
    case 'match':
    case 'scorecard':
    case 'preview':
    case 'recap':
    case 'report':
    case 'commentary':
    case 'statistics':
    case 'coverage':
    case 'matchstats':
    case 'playerstats':
    case 'conversation':
    case 'lineups':
    case 'video':
    case 'hawkeye':
      require.ensure([], (require) => {
        cb(null, require('../containers/GamePackage').default)
      })
      break
    // Case added for testing
    case 'info':
      // Enables webpack code splitting/chunks
      require.ensure([], (require) => {
        cb(null, require('../containers/List').default)
      })
      break
    case 'table':
    case 'standings':
      require.ensure([], (require) => {
        cb(null, require('../containers/Standings').default)
      })
      break
    case 'scoreboard':
    case 'scores':
      require.ensure([], (require) => {
        cb(null, require('../containers/Scoreboard').default)
      })
      break
    case 'schedule':
    case 'fixtures':
    case 'results':
      require.ensure([], (require) => {
        cb(null, require('../containers/Schedule').default)
      })
      break
    case 'team':
      require.ensure([], (require) => {
        cb(null, require('../containers/Clubhouse').default)
      })
      break
    case 'static':
      require.ensure([], (require) => {
        cb(null, require('../containers/StaticLandingPage').default)
      })
      break
    default:
      cb(null, Home)
  }
}

/**
 * Get name of sports from location object
 * @param  {Object} location location
 * @return {String}          name of sports
 */
function getSportName(location) {
  let fullPath = location.pathname || ''
  // Sport name is at 2nd position of splitted array
  let sportName = fullPath.split('/')[1] || ''
  return sportName
}


/**
 * Parse urls for all sport pages
 * @param  {Object}   nextState updated state
 * @param  {Function} cb       router cb function
 * @return {void}
 */
const parseSportPage = (nextState = {}, cb) => {
  const location = nextState.location
  let pageIdx = 1
  // List of sports which are supported by sCoreNode
  const validSports = [ 'rugby', 'nrl' ]
  // Get sport name from location
  const sportName = getSportName(location)
  // If cricket is available or sport is supported, pick pagetype from index 2
  if (isCricketAvailble(location) || validSports.indexOf(sportName) > -1) {
    pageIdx = 2
  }
  const params = {
    pageType: location.pathname.split('/')[pageIdx]
  }
  //console.info('params', params)
  getSportComponent(params, cb)
}

const parseCricketPage = (nextState = {}, cb) => {
  const location = nextState.location
  let pageIdx = isCricketAvailble(location) ? 2 : 1
  const params = {
    pageType: location.pathname.split('/')[pageIdx]
  }
  getSportComponent(params, cb)
}

/**
 * Parse urls for cricket game package
 * @param  {Object}   nextState updated state
 * @param  {Function} cb       router cb function
 * @return {void}
 */
const parseCricketGame = (nextState = {}, cb) => {
  const location = nextState.location
  let pageIdx = isCricketAvailble(location) ? 4 : 3
  //console.info('isCricketAvailble, pageIdx', isCricketAvailble, pageIdx)
  const params = {
    pageType: location.pathname.split('/')[pageIdx]
  }
  //console.info('parseCricketGame:params', params)
  getSportComponent(params, cb)
}

const parseStaticLandingPage = (nextState, cb) => {
  //const location = nextState.location
  const params = {
    pageType : 'static'
  }
  getSportComponent(params, cb)
}

/**
 * Check whether the sport name is 'cricket' or not a sport
 * @param  {Object}   location location object from router
 * @return {Boolean}  true if cricket is availble else false
 */
const isCricketAvailble = (location) => {
  let sportName = getSportName(location)
  // Is cricket part of the URL?
  return sportName === 'cricket' ? true : false
}

/**
 * onEnter callback that updates page shell
 * @param  {Object}   nextState    next router state
 * @param  {Function}   transition router transition
 * @param  {Function} callback     callback to continue render
 * @return {void}
 */
function onEnter(nextState, transition, callback) {
  /*if(process.browser === true) {
    try{
      const { pageType, sport = 'cricket' } = nextState.params
      const template = mapPageToTemplate({ pageType, sport })

      shell.transition.preRender(sport, template)
    }catch(e) {
      console.log(e)
    }
  }*/

  callback()
}

const routesDefault = (
  <Route onEnter={onEnter} component={App} path="/">
    <Redirect from="cricket/game" to="cricket/series/901359/game/951331/slug" />
    { /*Cricket GamePackage route*/ }
    <Route path="(:sport/)series/:league/:pageType/:gameId(/day/:day)(/:slug)(/:platform)(/:webview)" getComponent={parseCricketGame} />
    { /* Route for static page used for app preload */ }
    <Route path=":sport/static/:pageType/:platform/:webview" getComponent={parseStaticLandingPage} />
    { /*Route config for generic sport pages*/ }
    <Route path=":sport/:pageType" getComponent={parseSportPage}>
      <Route name="standingsParams" path="_(/sort/:sortKey)(/dir/:sortDir)(/league/:league)(/season/:season)(/seasontype/:seasontype)" />
      <Route name="standingsParamsCric" path="(sort/:sortKey/)(dir/:sortDir/)(series/:league)(/season/:season)(/:slug)" />
      <Route name="scoreboardParams" path="(_)(/team/:team)(/league/:league)(/date/:date)(/season/:season)" />
      <Route name="teamScoreboardParams" path="(team/:team)(/:slug)" />
      {/*<Route name="gamepackageParams" path="(:gameId)(/:leagueId)(/:period)(/:slug)" />*/}
      <Route name="matchParams" path="(_)(/gameId/:gameId)(/league/:league)(/:slug)" />
      <Route name="gamepackageWebviewWithAction" path="(_)(/gameId/:gameId)(/league/:league)(/action/:action)(/:platform)(/:webview)" />
      <Route name="clubhouseParams" path="_/id/:team(/:slug)" />
      <Route name="matchwebview" path=":platform/:webview" />
      <Route name="gamepackageWebview" path=":platform/:webview/(_)(/gameId/:gameId)(/league/:league)(/:slug)" />
    </Route>
    <IndexRoute component={Home} />
  </Route>
)

const routesCricinfo = (
  <Route onEnter={onEnter} component={App} path="/">
    <Redirect from="cricket/game" to="cricket/series/901359/game/951331/slug" />
    { /*Cricket GamePackage route*/ }
    { /* TODO: Fix trailing slash issue for table home page */ }
    <Route name="standingsParamsCricinfo" path="(cricket/):pageType/(sort/:sortKey/)(dir/:sortDir/)(series/:league)(/season/:season)(/:slug)" getComponent={parseSportPage} />
    <Route path="(:sport/)series/:league/:pageType/:gameId(/day/:day)(/:slug)(/:platform)(/:webview)" getComponent={parseCricketGame} />
    { /* Route for static page used for app preload */ }
    <Route path=":sport/static/:pageType/:platform/:webview" getComponent={parseStaticLandingPage} />

    <Route path="(cricket/):pageType" getComponent={parseCricketPage}>
      <Route name="scoreboardParams" path="(/team/:team)(/series/:league)(/date/:date)(/season/:season)" />
      <Route name="teamScoreboardParams" path="(team/:team)(/:slug)" />
    </Route>
    <IndexRoute component={Home} />
  </Route>
)


/**
 * Route configuration
 */
export { routesDefault }
export { routesCricinfo }
export default {
  routesDefault,
  routesCricinfo
}



// WEBPACK FOOTER //
// ../app/routes/index.js